module.exports = __webpack_public_path__ + "static/media/ok.22377b4d.svg";